import axios from 'axios';
import env from './env';

const apiUrl = env.NODE_ENV === 'production' ? 'prod' : 'dev';

export const BASE_URL = `${env.API_ENDPOINT}/${apiUrl}`;

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});



// WEBPACK FOOTER //
// lib/api.js